import React, { useState } from "react";
import { toast } from "react-toastify";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { useLoading } from "../Utils/LoadingContext";

function AttendanceSync() {
    const [startDateTime, setStartDateTime] = useState("");
    const [endDateTime, setEndDateTime] = useState("");
    const { setLoading } = useLoading();

    const handleSync = async (e) => {
        e.preventDefault();

        if (!startDateTime || !endDateTime) {
            toast.error("Please select Start Date & End Date");
            return;
        }

        if (new Date(startDateTime) > new Date(endDateTime)) {
            toast.error("Start Date must be equal or less than End Date");
            return;
        }

        try {
            setLoading(true);
           
            const response =
                await EmployeeProcessService.kentAttendanceSync(
                    startDateTime,
                    endDateTime
                );

            if (response.data.statusCode == 200) {
                alert(response.data.message + '| Total Featch:' + response.data.totalFetched + '|Inserted:' + response.data.inserted);
            } else {
                toast.error(response.data.message || "Sync failed");
            }

        } catch (error) {
            toast.error("Unexpected error occurred");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSync}>
            <div className="row">

                <div className="col-md-3">
                    <label>Start Date & Time</label>
                    <input
                        type="datetime-local"
                        className="form-control"
                        value={startDateTime}
                        onChange={(e) => setStartDateTime(e.target.value)}
                    />
                </div>

                <div className="col-md-3">
                    <label>End Date & Time</label>
                    <input
                        type="datetime-local"
                        className="form-control"
                        value={endDateTime}
                        onChange={(e) => setEndDateTime(e.target.value)}
                    />
                </div>

                <div className="col-md-2 d-flex align-items-end">
                    <button type="submit" className="btn btn-primary w-100">
                        Sync Attendance
                    </button>
                </div>

            </div>
        </form>
    );
}

export default AttendanceSync;
